module.exports = __webpack_public_path__ + "static/iitkgpcover-66b8e6adc14fbbaa0f7ebbd0cc07d029.jpg";